module.exports = __webpack_public_path__ + "img/5d5e476.jpg";